import { render, staticRenderFns } from "./Design3.vue?vue&type=template&id=32e5d3f4&"
import script from "./Design3.vue?vue&type=script&lang=js&"
export * from "./Design3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports